import viewport from '~/mixins/viewport'

export default {
  mixins: [viewport],

  props: {
    content: {
      type: Object,
      required: true,
    },

    labels: {
      type: Object,
      required: true,
    },

    links: {
      type: Object,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    isCentered: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    activeLink() {
      return this.isMobile ? this.links.mobile : this.links.desktop
    },

    activeLabel() {
      return this.isMobile ? this.labels.mobile : this.labels.desktop
    },

    activeCtaPrefix() {
      if (!this.labels.ctaPrefix) return null

      return this.isMobile
        ? this.labels.ctaPrefix.mobile || this.labels.ctaPrefix
        : this.labels.ctaPrefix.desktop || this.labels.ctaPrefix
    },

    activeText() {
      return this.isMobile ? this.content.mobile : this.content.desktop
    },

    linkAttrs() {
      const { href, target, ...rest } = this.activeLink

      return rest
    },
  },
}
